import { createInvalidStateError } from '../factories/invalid-state-error';
export var wrapAudioBufferSourceNodeStartMethodConsecutiveCalls = function wrapAudioBufferSourceNodeStartMethodConsecutiveCalls(nativeAudioBufferSourceNode) {
  nativeAudioBufferSourceNode.start = function (start) {
    var isScheduled = false;
    return function () {
      var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var duration = arguments.length > 2 ? arguments[2] : undefined;
      if (isScheduled) {
        throw createInvalidStateError();
      }
      start.call(nativeAudioBufferSourceNode, when, offset, duration);
      isScheduled = true;
    };
  }(nativeAudioBufferSourceNode.start);
};